import { AxiosError } from "axios";
import qs from "query-string";
import { useMutation } from "react-query";
import { NewConversationResponse, DAChatType } from '../types';
import axiosClient from '../utils/axiosClient';

export const useNewConversationMutation = (
  cb: (err: boolean, msg?: string) => void
) => {
  return useMutation<
    NewConversationResponse,
    AxiosError<any>,
    {
      chatName: string;
      conversationType: DAChatType;
    },
    any
  >(
    async ({ chatName, conversationType }) => {
      const { data } = await axiosClient.post(`/conversation/new`, {
        name: chatName,
        conversationType,
      });
      return data;
    },
    {
      onError: ({ response }) => {
        cb(true, 'Something went wrong.');
      },
      onSuccess: () => {
        cb(false);
      },
    }
  );
};
